/**
 * Processes view_item_list JSON data islands on initial page load.
 *
 * Islands are emitted by snippets/gtm-view-item-list.liquid as
 * <script type="application/json" data-gtm-view-item-list>.
 * Infinite-scroll pages are handled separately in paginated-list.js
 * because those scripts are never inserted into the live DOM.
 */
import { processViewItemListIslands } from '@theme/gtm-events';

processViewItemListIslands(document);
